import * as Sentry from "@sentry/react";
import { env } from "./env";

Sentry.init({
  dsn: env.PUBLIC_SENTRY_DSN,
  telemetry: false,
  enabled: env.PUBLIC_SENTRY_ENABLED,
  // Sentry 10.71 enables structured logs by default. Preserve the existing
  // error-and-trace-only behavior until the application adopts Sentry logs.
  enableLogs: false,

  // Reduce sample rate to prevent rate limiting (10% of traces)
  tracesSampleRate: env.PUBLIC_ENV === "development" ? 0.1 : 0.25,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [env.PUBLIC_PLATFORM_URL],

  integrations: [Sentry.browserTracingIntegration()],
  // Ignore common/noisy errors that don't need tracking
  ignoreErrors: [
    // Browser extensions and ResizeObserver
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
    // Network errors (expected in normal operation)
    "NetworkError",
    "Network request failed",
    "Failed to fetch",
    // A route/dialog chunk the newer deployment replaced. `ErrorFallback`
    // reloads into the new build, so the user sees an update, not a failure.
    // Chrome's phrasing already matches "Failed to fetch" above.
    "error loading dynamically imported module",
    "Importing a module script failed",
    // Cancelled requests (user navigation)
    "AbortError",
    "cancelled",
    // Sentry's own errors
    "sentry.io",
    // TipTap DOM errors (race condition with React collaborative editing)
    "The object can not be found here",
    "NotFoundError",
    "insertBefore",
    "is not a child of this node",
  ],

  // Filter events before sending
  beforeSend(event, hint) {
    const error = hint.originalException;

    // Don't send if Sentry itself is rate limited
    if (error?.message?.includes("sentry.io")) {
      return null;
    }

    // Don't send in development mode
    if (env.PUBLIC_ENV === "development") {
      return null;
    }

    return event;
  },
});
